
export class TransitionFormInstances {
    public formsGridFormFieldId: number;
    public workflowTransitionId: number;
    public formInstanceIds: number[];
}
